import React from 'react';
import PropTypes from 'prop-types';

const Checkmark = ({color = 'gray', width = '100%', height = '100%'}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24">
    <path fill={color} d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z" />
  </svg>
);

Checkmark.propTypes = {
  /**
   * Color hex
   */
  color: PropTypes.string,

  /**
   * Icon width
   */
  width: PropTypes.string,

  /**
   * Icon height
   */
  height: PropTypes.string,
};

export default Checkmark;
